import React from 'react'
import SuperUserTxnPageUI from '../../../templates/SuperUserTxnPageUI.js'
import MutualFundsListUI from '../../../components/superUser/nodalTxn/MutualFundsListUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const MutualFundsListPageUI = ({
  context, accountNumber, onRefreshClick,
  mfTransferList, totals, mfTransactions, mfMonthlyTotals, mfTxnList,
  financialYear, financialYearList, onFinancialYearChange
}) =>
  <SuperUserTxnPageUI context={context} className='pg_su_mf' topnav='transactions' backLink='/su/accounts'
    headerText='Accounts' centered={!totals}
    page={accountNumber === '007105010733' ? '0733mutualFunds' : accountNumber === '038605004441' ? '4441mutualFunds' : '4412mutualFunds'}
  >
    {
      (!totals) &&
      <SpinnerComponentUI />
    }
    {
      totals &&
      <MutualFundsListUI
        context={context}
        accountNumber={accountNumber}
        mfTransferList={mfTransferList}
        mfTransactions={mfTransactions}
        mfTxnList={mfTxnList}
        totals={totals}
        mfMonthlyTotals={mfMonthlyTotals}
        onRefreshClick={onRefreshClick}
        //
        financialYear={financialYear}
        financialYearList={financialYearList}
        onFinancialYearChange={onFinancialYearChange}
      />
    }

  </SuperUserTxnPageUI>

export default MutualFundsListPageUI
